import React from "react";

const ReturnRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  d: "M4.81582 9.44L6.79089 11.1704C6.99826 11.3521 7.00815 11.6559 6.81298 11.849C6.6178 12.0421 6.29148 12.0512 6.08411 11.8695L3.16224 9.30951C3.05871 9.21882 3 9.09235 3 8.96C3 8.82765 3.05871 8.70119 3.16224 8.61043L6.08411 6.05046C6.29148 5.86877 6.6178 5.87798 6.81298 6.07103C7.00815 6.26407 6.99826 6.56785 6.79089 6.74954L4.81581 8.48H11.7656C12.4301 8.48 12.9688 7.97856 12.9688 7.36V4.48C12.9688 4.21491 13.1996 4 13.4844 4C13.7691 4 14 4.21491 14 4.48V7.36C14 8.50874 12.9996 9.44 11.7656 9.44H4.81582Z",
  fill: "currentColor"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(ReturnRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;